exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".contact--row--3VvnI5FI {\r\n  margin-top: 16px;\r\n}\r\n\r\n.contact--formContainer--drE_f_pU {\r\n  background-color: #f6f8f8;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/help/contact/contact.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB;;AAED;EACE,0BAA0B;CAC3B","file":"contact.css","sourcesContent":[".row {\r\n  margin-top: 16px;\r\n}\r\n\r\n.formContainer {\r\n  background-color: #f6f8f8;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"row": "contact--row--3VvnI5FI",
	"formContainer": "contact--formContainer--drE_f_pU"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/help/contact/contact.css
// module id = 384
// module chunks = 0